import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { RestService } from '../../../services/rest/rest.service';
import { InvestmentGoal } from '../../../domain/lti/lti.domain';
import { RestOptions } from '../../../services/rest/rest-request';

@Injectable({
  providedIn: 'root'
})
export class GoalRestService {
  private readonly restService = inject(RestService);

  /**
   * Get goal by id
   *
   * @return
   */
  getGoal(goalId: string): Observable<InvestmentGoal> {
    const restOptions: RestOptions = {
      pathVariables: {
        goalId
      }
    };
    return this.restService.getResource('wealthInvestment.getInvestmentGoalById')
      .get(restOptions);
  }

  /**
   * Post goal
   *
   * @param
   * @return
   */
  createGoal(goal: InvestmentGoal):
  Observable<InvestmentGoal> {
    return this.restService.getResource('wealthInvestment.postInvestmentGoal')
      .post(goal);
  }

  /**
   * Patch goal
   *
   * @param
   * @return
   */
  updateGoal(id: string, goal: InvestmentGoal):
  Observable<InvestmentGoal> {
    // WIPP doesnt allow profileModelId in patch call
    // JIRA WB-14623
    goal.profileModelId = undefined;
    const restOptions: RestOptions = {
      pathVariables: {
        goalId: id
      }
    };
    return this.restService.getResource('wealthInvestment.updateInvestmentGoal')
      .patch(goal, restOptions);
  }
}

